import React, { type ReactElement } from 'react'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'

import { Button } from '~components/common'

type ConfirmDeleteModalProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  title?: string
  description?: string
  itemName?: string
}

const ConfirmDeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Deletion',
  description = 'Are you sure you want to delete this item? This action cannot be undone.',
  itemName,
}: ConfirmDeleteModalProps): ReactElement => {
  const handleCancelClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    onClose()
  }

  const handleConfirmClick = (e: React.MouseEvent): void => {
    e.stopPropagation()
    onConfirm()
  }

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id='alert-dialog-description'>
          {itemName ? `Are you sure you want to delete "${itemName}"? ` : description}
        </DialogContentText>
        {itemName && (
          <DialogContentText id='alert-dialog-description'>
            This action cannot be undone.
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancelClick} color='secondary' variant='outlined'>
          Cancel
        </Button>
        <Button onClick={handleConfirmClick} color='secondary' variant='contained' autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDeleteModal
